import {_} from 'vue-underscore';
import api from "../utils/api.js";
import { trackEvent } from '../utils/tracking';
import {RETURN_PAGE_SAVED_OUTFITS} from "../../config.js";

export const products = {
    namespaced: true,
    state: {
        currentProduct: {},
        products: [],
        swapGaeVersion: null,
    },
    getters: {
        products(state) {
            return state.products;
        },
        getCurrentProduct(state){
            return state.currentProduct;
        },
        gaeVersion(state) {
            return state.swapGaeVersion;
        }
    },
    mutations: {
        setCurrentProduct(state, payload){
            console.log('setting current product ---- ')
            console.log(payload);
            state.currentProduct = payload.response.product;
        },
        setGaeVersion(state, gaeVersion) {
            state.swapGaeVersion = gaeVersion;
        },
        resetState(state){
            state.currentProduct = {};
            state.products = [];
        }
    },
    actions: {
        changeCurrentProduct (context, payload) {
            console.log('changing product --- ' + payload.product)
            context.commit("setCurrentProduct", {
                response: {
                    product: payload.product
                }
            });
        },
        fetchProduct(context, payload) {
            let uri = api.productsUri();
            return api
                .get(uri + payload.id, {params: {outfit_id: payload.outfitId, product_option_value_id: payload.productOptionValueId}})
                .then(response => {
                    context.commit("setCurrentProduct", {
                        response: response
                    });
                })
                .catch(error => {});
        },
        fetchSubstituteProducts(context, payload) {
            const { sizeId: size_id, product } = payload;
            
            const uri = product.outfit_id
                ? `${api.outfitsUri()}/${product.outfit_id}/products/${product.product_id}`
                : `${api.productsUri()}substitute/${product.product_id}`;

            // Load filters from filter module
            const {
                minPrice: outfit_price_min,
                maxPrice: outfit_price_max,
            } = context.rootGetters["filters/selectedFilters"];

            const params = {
                outfit_price_min,
                outfit_price_max,
                size_id,
                color_id: (!product.outfit_id) ? product.product_option_value_id : null,
            };

            return api
                .get(uri, {
                    params
                })
                .then(response => {
                    context.commit('setGaeVersion', response.gae_version);
                    return response.products;
                })
                .catch(error => {
                    trackEvent("swap_error", {content_id: payload.product.product_id});
                    throw error;
                })
        }
    }
};